/**
 * Break-Glass Auth Service (Spec 0044)
 *
 * API-Call an Break-Glass Endpoint + sessionStorage Token-Handling.
 * Token wird in sessionStorage gespeichert (Tab-gebunden, nicht persistent).
 */

import { API_BASE_URL } from '../utils';

const BREAK_GLASS_TOKEN_KEY = 'break-glass-token';

/**
 * Break-Glass Sign-In: Sendet Passwort an Backend, speichert JWT in sessionStorage.
 */
export async function breakGlassSignIn(password: string): Promise<{
  success: boolean;
  token?: string;
  error?: string;
}> {
  const url = `${API_BASE_URL}/auth/break-glass`;

  const response = await fetch(new URL(url, window.location.origin).toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password }),
  });

  if (response.ok) {
    const data = await response.json();
    sessionStorage.setItem(BREAK_GLASS_TOKEN_KEY, data.token);
    return { success: true, token: data.token };
  }

  return { success: false, error: 'ACCESS_DENIED' };
}

/**
 * Prueft ob ein Break-Glass Token in der aktuellen Session vorhanden ist.
 */
export function hasBreakGlassToken(): boolean {
  return !!sessionStorage.getItem(BREAK_GLASS_TOKEN_KEY);
}

/**
 * Gibt das Break-Glass Token zurueck (oder null).
 */
export function getBreakGlassToken(): string | null {
  return sessionStorage.getItem(BREAK_GLASS_TOKEN_KEY);
}

/**
 * Entfernt das Break-Glass Token (Sign-Out).
 */
export function clearBreakGlassToken(): void {
  sessionStorage.removeItem(BREAK_GLASS_TOKEN_KEY);
}
